export enum CouponType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
  FREE_EVENT = 'freeEvent',
  VIP = 'vip',
}
